
import {createSlice} from "@reduxjs/toolkit";

export const licenseSlice = createSlice({
    name: 'licenseSlc',
    initialState: {value: {id: null, externalId: null, licenseAmount: null, displayAmount: null, availBegin: null,
            availEnd: null, executionDate: null, licensee: null, licenseMarket: null, licenseTerritory: null,
            propertyId: null, exhibitionDays: null, licensedRuns: null, status: null,
            createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
            propertyName: null, initialMarket: null, genre: null, productionType: null,
            licenseDrawerState: false, licenseDrawerMode: null, licenseGridRefresh: false
        }},
    reducers:

{
    changeLicense: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeLicense } = licenseSlice.actions;

export default  licenseSlice.reducer ;
